module.exports = __webpack_public_path__ + "4858b5b4d10aab72b56f5e42f61acbed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/popsicle.png
// module id = 2873
// module chunks = 0